var scalingFonts = document.querySelectorAll('.ccfs-scale'), i;

if (scalingFonts.length > 0) {
    
}
for (i = 0; i < scalingFonts.length; ++i) {
    charLen(scalingFonts[i])
}

function charLen(ele) {
    var charLen = ele.innerHTML.length
    var charPercent = 100 
    var minPercent = 40 // Default. Overridden by fs-min-percent attribute on each element
    var scaleRate = 1 // Default. Overridden by "fs-scale-rate" attribute 
    var scaleStart = 10

    ele.setAttribute('ccfs-scaled', false) // Default false. Only to show it's changed, not funtional

    if (ele.hasAttribute("ccfs-scale-rate")) {
        scaleRate = ele.getAttribute("ccfs-scale-rate")
    }

    if (ele.hasAttribute("ccfs-min-percent")) {
        minPercent = ele.getAttribute("ccfs-min-percent")
    }

    if (ele.hasAttribute("ccfs-cc-start")) {
        scaleStart = ele.getAttribute("ccfs-cc-start")
    }

    if (charLen > scaleStart) {
        charPercent = 100 - ((charLen - scaleStart) * scaleRate)
    }

    if (charPercent < minPercent) {
        charPercent = minPercent
    }

    var charPercentDecimal = charPercent / 100
    ele.style.setProperty('--charCountOffsetPercent', charPercentDecimal);

    
    if (charPercent < 100) {
        ele.setAttribute('ccfs-scaled', true)
    }

    ele.setAttribute('ccfs-length', charLen)
    ele.setAttribute('ccfs-length-percent', charPercent )

}